/**
 * React root — WP7 client entry point.
 *
 * Strict-mode on. Socket connect must be idempotent to survive React
 * 18's double-mount effect semantics (see the `WsClientProvider`).
 */

import { StrictMode, type ReactElement } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.js";
import { StoreProvider } from "./store/context.js";
import { WsClientProvider } from "./net/WsClientProvider.js";
import { SoundProvider } from "./sound/SoundProvider.js";
import { KeymapProvider } from "./input/keybinding/index.js";
import { WasdStrafeModeProvider } from "./input/wasdStrafeMode.js";

const el = document.getElementById("app");
if (el === null) {
  throw new Error("main: #app container missing from index.html");
}

// StrictMode is unconditional: PitSocket.connect() revives a disposed
// instance, so the mount → cleanup → mount cycle is safe (see socket.ts).
// The e2e harness runs the same tree as production.
const tree: ReactElement = (
  <StoreProvider>
    <WsClientProvider>
      <SoundProvider>
        <KeymapProvider>
          <WasdStrafeModeProvider>
            <App />
          </WasdStrafeModeProvider>
        </KeymapProvider>
      </SoundProvider>
    </WsClientProvider>
  </StoreProvider>
);

createRoot(el).render(
  <StrictMode>{tree}</StrictMode>,
);
